/* eslint-disable react/forbid-prop-types */
/* eslint no-underscore-dangle: 0 */
import React from "react"
import ReactDOM from "react-dom"
import propTypes from "prop-types"
import { Image, Flex } from "rebass"
import { navigate } from "gatsby"
import styled from "styled-components"
import ImageZoom from "react-medium-image-zoom"

import withTranslation from "../i18n/withTranslation"
import logoBlack from "../assets/logoBalmaceda.svg"
import MasonryItem from "./MasonryItem"

const Wrapper = styled.div`
  display: inline-block;
  margin-top: 60px;

  .vertical,
  .horizontal {
    margin: 30px 4%;
  }

  .vertical {
    max-width: 40%;
    > .picture {
      max-width: 100%;
    }
  }

  .horizontal {
    max-width: 75%;
    > .picture {
      max-width: 100%;
    }
  }

  .vertical:nth-child(even),
  .horizontal:nth-child(even) {
    float: left;
  }

  .vertical:nth-child(odd),
  .horizontal:nth-child(odd) {
    float: right;
  }

  div:nth-child(5),
  div:nth-child(12),
  div:nth-child(15) {
    max-width: 70%;
  }
`

const Loader = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  background: white;
  height: 100%;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;

  .loadDots {
    position: relative;
    text-align: center;
    margin: 15px 0 0 10px;

    > .dot {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 3px;
      background: #303131;
      animation: wave 1.3s linear infinite;

      &:nth-child(2) {
        animation-delay: -1.1s;
      }

      &:nth-child(3) {
        animation-delay: -0.9s;
      }
    }
  }

  @keyframes wave {
    0%,
    60%,
    100% {
      transform: initial;
    }

    30% {
      transform: translateY(-5px);
    }
  }
`

class MasonryComponent extends React.Component {
  constructor(props) {
    super(props)
    this.masonryRef = React.createRef()
    this.state = {
      items: {},
      loaded: false,
    }
  }

  componentDidMount() {
    this.arrangeMasonry()
  }

  handleZoom = i => {
    this.setState(prevState => ({
      items: {
        ...prevState.items,
        [i]: {
          ...prevState.items[i],
          zoomed: !prevState.items[i].zoomed,
        },
      },
    }))
  }

  handleRedirect = slug => {
    navigate(`${slug}`, { replace: false })
  }

  arrangeMasonry = () => {
    const _this = this
    // eslint-disable-next-line react/no-find-dom-node
    const container = ReactDOM.findDOMNode(this.masonryRef.current)

    const itemsArray = Array.from(container.children[0].children)
    let itemsLoaded = 0

    itemsArray.forEach((child, i) => {
      const image = child.children[0]

      image.onload = function defineClass() {
        itemsLoaded += 1
        const height = image.clientHeight
        const width = image.clientWidth
        if (width > height) {
          child.classList.add("horizontal")
          _this.setState({
            items: {
              ..._this.state.items,
              [i]: { orientation: "landscape", zoomed: false },
            },
          })
        } else {
          child.classList.add("vertical")
          _this.setState({
            items: {
              ..._this.state.items,
              [i]: { orientation: "portrait", zoomed: false },
            },
          })
        }

        if (itemsLoaded === itemsArray.length) {
          _this.setState({ loaded: true })
        }
      }
    })
  }

  render() {
    const { posts, type, t } = this.props
    const { items, loaded } = this.state
    return (
      <>
        {!loaded && (
          <Loader>
            <Flex>
              <Image
                src={logoBlack}
                width={["300px", "250px"]}
                style={{
                  cursor: "pointer",
                }}
              />
              <div className="loadDots">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </div>
            </Flex>
          </Loader>
        )}

        <Wrapper ref={this.masonryRef}>
          <div className="masonry-with-columns">
            {type === "page" &&
              posts.map(post => (
                <MasonryItem
                  key={post.node.id}
                  title={`${post.node.frontmatter.name} Collection`}
                  subtitle={t("gallery.viewMore")}
                  orientation="vague"
                  action={() => this.handleRedirect(post.node.fields.slug)}
                >
                  <Image src={post.node.frontmatter.featured} />
                </MasonryItem>
              ))}

            {type === "gallery" &&
              posts.map((post, i) => (
                <MasonryItem
                  key={post.node.id}
                  title={post.node.frontmatter.subtitle}
                  subtitle={post.node.frontmatter.description}
                  orientation={items[i] ? items[i].orientation : null}
                  action={() => this.handleZoom(i)}
                >
                  <ImageZoom
                    image={{
                      src: `${post.node.frontmatter.thumbnail}`,
                      className: "picture",
                    }}
                    isZoomed={items[i] ? items[i].zoomed : false}
                  />
                </MasonryItem>
              ))}
          </div>
        </Wrapper>
      </>
    )
  }
}

MasonryComponent.propTypes = {
  posts: propTypes.array.isRequired,
  type: propTypes.oneOf(["gallery", "page"]),
  t: propTypes.func.isRequired,
}

export default withTranslation(MasonryComponent)
